import { useSearchPageRequestId } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { trackSearchBrandsofffairequeryclickActionCategoryClick } from "@faire/web-api--source/events/search/actionCategoryClick/brandsofffairequeryclick";
import { IBrandOffFaireQueryRewritingResponse } from "@faire/web-api--source/indigofair/data/IBrandOffFaireQueryRewritingResponse";
import { getCurrentPath } from "@faire/web/common/Path";
import { Button } from "@faire/web/slate/Button";

export const SearchPageBrandsOffFaireText = ({
  brandsOffFaireQuery,
}: {
  brandsOffFaireQuery: IBrandOffFaireQueryRewritingResponse;
}) => {
  const requestId = useSearchPageRequestId();
  const linkPath = getCurrentPath()
    .replace({
      q: encodeURIComponent(brandsOffFaireQuery.raw_query),
      noBrandsOffFaireQuery: "true",
      doQuerySpellCheck: "",
    })
    .toString();

  return (
    <>
      {`${brandsOffFaireQuery.escape_hatch_prefix} `}
      <Button
        variant="tertiary"
        linkTo={linkPath}
        tertiaryColor="inherit"
        data-test-id="brands-off-faire-escape-hatch"
        onClick={() => {
          trackSearchBrandsofffairequeryclickActionCategoryClick(
            brandsOffFaireQuery.raw_query,
            brandsOffFaireQuery.identified_brand_name,
            requestId ?? ""
          );
        }}
        style={{
          fontFamily: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          letterSpacing: "inherit",
        }}
      >
        {`"${brandsOffFaireQuery.raw_query}"`}
      </Button>
    </>
  );
};
